import React from 'react';

import NoticeHeader from 'components/checkout/modal-notices/notice-headers/notice-header';

const HeadsUpHeader = () => (
  <NoticeHeader headerImgSrc="/images/checkout/zag-24-hr.png">A quick heads up</NoticeHeader>
);

export default HeadsUpHeader;
